import { RefObject, useEffect } from 'react';

type UseOutsideClick = <T extends HTMLElement>(
	ref: RefObject<T | null>[] | RefObject<T>,
	callback: () => void,
	checkDomOrder?: boolean
) => void;

export const useOutsideClick: UseOutsideClick = (ref, callback, checkDomOrder) => {
	const handleClick = (event: MouseEvent): void => {
		const refArray = Array.isArray(ref) ? ref : [ref];
		if (refArray.length === 0) return;

		const clickX = event.clientX;
		const clickY = event.clientY;

		let clickedInside = false;

		// eslint-disable-next-line no-restricted-syntax
		for (const singleRef of refArray) {
			if (singleRef && singleRef?.current) {
				const fixedRef = singleRef?.current || singleRef;
				const refRect = fixedRef.getBoundingClientRect();
				const clickIsOutsideRef =
					clickX < refRect.left || clickX > refRect.right || clickY < refRect.top || clickY > refRect.bottom;

				const targetIsInsideRef = checkDomOrder && fixedRef.contains(event.target as Node);
				if (!clickIsOutsideRef || targetIsInsideRef) {
					clickedInside = true;
				}
			}
		}

		if (!clickedInside) {
			callback();
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClick);

		return () => {
			document.removeEventListener('click', handleClick);
		};
	});
};

export default useOutsideClick;
